import { render } from "./SidebarMenu.vue?vue&type=template&id=37903aac"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__